{
  "sticky_notes": "Sticky Notes"
}
